import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import NativeLandingPage from './pages/NativeLandingPage/NativeLandingPage';
import CalendlyInscriptionPage from './pages/CalendlyInscriptionPage/CalendlyInscriptionPage';
import InscriptionStep2Page from './pages/InscriptionPage/InscriptionStep2Page';
import InscriptionStep3Page from './pages/InscriptionPage/InscriptionStep3Page';
import InscriptionStep4Page from './pages/InscriptionPage/InscriptionStep4Page';
import WeeklyTalkPage from './pages/WeeklyTalkPage/WeeklyTalkPage';
import PortalPage from './pages/PortalPage/PortalPage';
import HomePage from './pages/HomePage/HomePage';
import AdmisionesPage from './pages/AdmisionesPage/AdmisionesPage';
import BecasPage from './pages/BecasPage/BecasPage';
import SobreNosotrosPage from './pages/SobreNosotrosPage/SobreNosotrosPage';
import AdminPage from './pages/AdminPage/AdminPage';
import './App.css';

function RouteTracking() {
  const location = useLocation();
  const previousPage = useRef(null);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;

    // El HTML base registra la primera vista. Aquí solo medimos navegación SPA.
    if (previousPage.current === null) {
      previousPage.current = pagePath;
      return;
    }

    if (previousPage.current === pagePath) return;
    previousPage.current = pagePath;

    const pageData = {
      page_location: window.location.href,
      page_path: pagePath,
      page_title: document.title,
    };

    window.dataLayer?.push({
      event: 'virtual_page_view',
      ...pageData,
    });
    window.gtag?.('event', 'page_view', pageData);
    window.fbq?.('track', 'PageView');
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <RouteTracking />
      <Routes>
        <Route path="/" element={<NativeLandingPage />} />
        <Route path="/inscripcion" element={<CalendlyInscriptionPage />} />
        <Route path="/charla-semanal" element={<WeeklyTalkPage />} />
        <Route path="/inscripcion/paso-2" element={<InscriptionStep2Page />} />
        <Route path="/inscripcion/paso-3" element={<InscriptionStep3Page />} />
        <Route path="/inscripcion/paso-4" element={<InscriptionStep4Page />} />
        <Route path="/oferta" element={<AdmisionesPage />} />
        <Route path="/becas" element={<BecasPage />} />
        <Route path="/nosotros" element={<SobreNosotrosPage />} />
        <Route path="/portal" element={<PortalPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
